import {Injectable} from "@angular/core";
import {Http, RequestOptions, Response} from "@angular/http";
import {UtilService} from "../util";
import {AuthService} from "../auth";
import {Observable} from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";
import "rxjs/add/observable/of";
import {PhysicianModel} from "../../models/physician.model";

/**
 * This class provides the Patient service with methods to read patients
 */
@Injectable()
export class PhysicianService {
  constructor(private http: Http,
              private utilService: UtilService,
              private authService: AuthService) {
  }


  getUrl(system: boolean) {
    return system ? '/system_providers' : `/physicians`;
  }

  getPhysicianById(id: string): Observable<PhysicianModel> {
    return this.http
      .get(this.getUrl(true) + '/' + id)
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};

      })
      .catch(this.utilService.handleError);
  }

  updatePhysician(physician: PhysicianModel) {
    const url = this.getUrl(true) + '/' + physician.Id;
    return this.http.put(url, physician)
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};

      })
      .catch(this.utilService.handleError);
  }

  setVisibility(id: string, visible: boolean) {
    const data = {
      Visible: visible
    };
    const url = this.getUrl(true) + '/' + id;
    return this.http.patch(url, data)
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }

  getPhysicainsByLocation(locationId: number | string,
                          searchCriteria?: SearchCriteria): Observable<PhysicianModel[]> {
    let searchUrl: string = "/location/" + locationId + "/physicians";
    return this.http
      .get(searchUrl)
      .map((res: Response) => {
        return JSON.parse(res["_body"]);
      })
      .catch(this.utilService.handleError);
  }

  getPhysicians(searchCriteria: SearchCriteria = null, system: boolean = false, showAll: boolean = false): Observable<PhysicianModel[]> {
    let findUrl: string = this.getUrl(system);
    if (!searchCriteria) {
      searchCriteria = {
        PageNumber: 1,
        Sort: "",
        Order: "",
        SearchTerm: ""
      };
    }
    let queryParams = this.utilService.setQueryParams({
      sort: searchCriteria.Sort,
      order: searchCriteria.Order,
      search: searchCriteria.SearchTerm,
      page: searchCriteria.PageNumber,
      show_all: showAll ? 'true' : 'false'
    });
    let options = new RequestOptions({params: queryParams});

    return this.http
      .get(findUrl, options)
      .map(
        (res: Response) => this.utilService.outputParser(res) || []
      )
      .catch(this.utilService.handleError);
  }

  deactivate(physician: PhysicianModel) {
    let url = `/user/${physician.Id}/deactivate`;
    return this.http
      .post(url, {})
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }

  resendActivationEmail(physician: PhysicianModel) {
    let url = `/user/${physician.Id}/resend`;
    return this.http
      .post(url, {})
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }

  create(physician: PhysicianModel) {
    const url = this.getUrl(true);
    return this.http.post(url, physician)
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }

  checkInPatient(physicianId: number,
                 patientId: number): Observable<Array<any>> {
    let checkinUrl: string = `/physicians/${physicianId}/patients/${patientId}/check-in`;
    return this.http
      .post(checkinUrl, {})
      .map((res: Response) => this.utilService.outputParser(res) || {})
      .catch(this.utilService.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/physician/physician.service.ts